import React from "react";
import {useSelector} from "react-redux";
import EmailConfirmationModal from "./EmailConfirmationModal";
import EmailValidationModal from "./EmailValidationModal";
import EmailConfirmSuccess from "./EmailConfirmSuccess";

const ConfirmEmail = () => {
    const show_email_confirmation =  useSelector((state) => state.appReducer.show_email_confirmation);
    const show_email_validation =  useSelector((state) => state.appReducer.show_email_validation);
    const show_email_validation_success =  useSelector((state) => state.appReducer.show_email_validation_success);

    if(show_email_confirmation){
        return <EmailConfirmationModal />
    }

    if(show_email_validation){
        return <EmailValidationModal />
    }

    if(show_email_validation_success){
        return <EmailConfirmSuccess />
    }

    return null;
}

export default ConfirmEmail;